import { useNavigate } from "react-router-dom";
import "../styles/LegalPages.css";

export default function Disclaimer() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      {/* BACK BUTTON */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <h1>Disclaimer</h1>

      <p>
        The information contained in this website is for general information
        purposes only. The information is provided by{" "}
        <strong>Sprout Knowledge Solutions Pvt Ltd</strong> and while we endeavour
        to keep the information up to date and correct, we make no
        representations or warranties of any kind, express or implied, about the
        completeness, accuracy, reliability, suitability or availability with
        respect to the website or the information, products, services, or related
        graphics contained on the website for any purpose.
      </p>

      <p>
        Any reliance you place on such information is therefore strictly at your
        own risk. In no event will we be liable for any loss or damage including
        without limitation, indirect or consequential loss or damage, or any
        loss or damage whatsoever arising from loss of data or profits arising
        out of, or in connection with, the use of this website.
      </p>

      <p>
        Through this website you may link to other websites which are not under
        the control of Sprout Knowledge Solutions Pvt Ltd. We have no control over
        the nature, content, and availability of those sites. The inclusion of
        any links does not necessarily imply a recommendation or endorse the
        views expressed within them.
      </p>

      <p>
        Every effort is made to keep the website up and running smoothly.
        However, Sprout Knowledge Solutions Pvt Ltd takes no responsibility for,
        and will not be liable for the website being temporarily unavailable due
        to technical issues beyond our control.
      </p>

      <p className="legal-contact">
        <strong>Address:</strong> 381, Light House Road, Coimbatore, Tamil Nadu,
        India – 641001 <br />
        <strong>Email:</strong> info@sproutks.com <br />
        <strong>Website:</strong> sproutks.com
      </p>
    </div>
  );
}
